import React, { Component } from "react";
import AuthLayout from "./authLayout.js"
import SimpleReactValidator from 'simple-react-validator';

//Connect Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../redux/bindActionCretor'

import service from '../../services'
import { Link } from "react-router-dom";
import Loader from '../../component/loader'

import ViewIcon from './../../icons/viewIcon';
import ShowPasswordIcon from './../../icons/ShowPassIcon';

let sub;
const mapStateToProps = state => ({
    setToken : state.setToken,
    getLoginRole:state.getLoginRole
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};
class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            btnDisable:false,
            loaderFlag: false,
            showPass:false
        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        this.apiserve = new service();

    }

    componentDidMount = () => {
      //  this.apiserve.removeLocalstorage();
       sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                // case "getUser":
                //     this.props.ProfileName(response.data)
                //     if(response.data.role === "sio" || response.data.role === "press" || response.data.role === "sundanceCircle" || response.data.role === "sundanceGuest" || response.data.role === "general" || response.data.role === "artist"){
                //         this.props.history.push('/admin-dashboard')                   
                //     }else if(response.data.role === "partner"){
                //         // this.props.GetPartner(response.data)
                //         this.props.history.push('/profile-partner-view')                   
                //     }else{
                //         this.props.history.push('/access-management')                   
                //     }
                //     // this.props.history.push("/access-management");
                    
                // break;
                case "privateScreeningPartner|cms|login":
                    if(!response.error){
                        let data = response.data;
                        const newRole = data.userData.additionalRoles.filter(role => role !== "generalUser")[0];
                        data.user.role = newRole;
                        this.setState({ loaderFlag: false, btnDisable: false })
                        localStorage.setItem('loginToken', response.data.token)
                        localStorage.setItem('currentUserRole', data.user.role)

                        this.props.LoginToken(response.data.token)
                        this.props.LoginRole(data)
                        this.props.ProfileName(response.data);
                        this.props.history.push('/partners-film-view')
                    } else{
                        this.setState({ loaderFlag: false, btnDisable: false })
                        this.apiserve.error(response.data.error)
                    }           
                break;
                // case "authentication":
                //     this.setState({isAuthenticated: true,isLoading: false}, () => {
                //         if(this.props.setToken){
                //                 if(response && response.data && response.data.user && response.data.user.role === 'sio' || 
                //                     response && response.data && response.data.user && response.data.user.role === 'press' || 
                //                     response && response.data && response.data.user && response.data.user.role === 'sundanceCircle' ||
                //                     response && response.data && response.data.user && response.data.user.role === 'sundanceGuest' ||
                //                     response && response.data && response.data.user && response.data.user.role === 'general' ||
                //                     response && response.data && response.data.user && response.data.user.role === 'artist' ){
                //                     this.props.history.push('/admin-dashboard')
                //                 }else if(response && response.data && response.data.user && response.data.user.role === 'partner'){
                //                     this.props.history.push('/profile-partner-view')
                //                 }else{
                //                     this.props.history.push('/access-management')
                //                 }
                //             }
                //     })
                //     break;
                default:
                    return null
            }
        })
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
      }

    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    }

    login = () => {
        this.apiserve.sendevent("privateScreeningPartner|cms|login", { email: this.state.email, password:this.state.password });
      }

    submitFn = async (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                loaderFlag: true,
            });
            this.setState({ btnDisable: true })
            this.login();
        }
        else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    clearFn = () => {
        this.setState({
            email: "",
            password: ""
        });
    };

    Showpassword = () => {
        this.setState({
            showPass: !this.state.showPass
        })
    }

    render() {
        const {btnDisable} = this.state;
        return (
            <AuthLayout>
                {/* Box Design Start here */}
                <div className="box_wrapper signIn_box_Wrapper">
                    <h2>Partner Sign In</h2>
                    <form onSubmit={() => this.submitFn()}>
                        <div>
                            <label>Email</label>
                            <input
                                type="email"
                                name="email"
                                id="email"
                                maxLength={255}
                                value={this.state.email}
                                onChange={this.onInputChange}
                            />
                            <span style={{ color: 'red' }}>{this.validator.message('Email', this.state.email, 'required|email')}</span>
                        </div>
                        <div>
                            <label>Password</label>
                            <div className="relative">
                                <input
                                    type={this.state.showPass ? 'text' : 'password'}
                                    name="password"
                                    id="password"
                                    value={this.state.password}
                                    onChange={this.onInputChange} />
                                    <span className="eye_icon" onClick={this.Showpassword}>
                                        {
                                            this.state.showPass ? <ShowPasswordIcon />  : <ViewIcon />
                                        }
                                        
                                        
                                    </span>
                            </div>
                            <span style={{ color: 'red' }}>{this.validator.message('Password', this.state.password, 'required')}</span>
                        </div>
                        <div>
                            <Link to='/ps-forget'>Forgot Password</Link>
                        </div>
                        <div>
                            <button
                                className="grayBTN"
                                type="button"
                                onClick={() => this.clearFn()}
                            >Clear</button>
                            <button
                                type="submit"
                                disabled={btnDisable === true ? true : false}
                                onClick={(e) => this.submitFn(e)}
                                className="orangeBTN"
                            >Submit</button>
                        </div>
                    </form>

                </div>
                {/* Box Design End's here */}

            {/* Loader */}
            {this.state.loaderFlag ? (
                <Loader/>
              ) : (
                  ""
            )}

           </AuthLayout>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Login)